// removed by extract-text-webpack-plugin
module.exports = {"vpTextCollectorContainer":"vpTextCollectorContainer___1Yonk","vpHeader":"vpHeader___2CydL","vpLabel":"vpLabel___4XQB6","vpDescription":"vpDescription___1Wgy6","vpRequiredLabel":"vpRequiredLabel___jqdZ0","vpTextField":"vpTextField___2vVpt","vpFooter":"vpFooter___D-Epg","vpCharacterCount":"vpCharacterCount___1wPjf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/TextCollector.module.less
// module id = 3832
// module chunks = 33